<template>
  <div class="app-event-creation">
    <EventActionBar
      :cur-action="curAction"
      @changeAction="curAction = $event"
      :loaded="!LOADING"
    />
    <EventActionOverlay
      :cur-action="curAction"
      @changeAction="curAction = $event"
      @scrollToWinners="scrollToWinners"
    />
    <AlertBar />
    <BannerTitle :title="eventName" :loading="LOADING" />
    <div class="grey" v-if="!LOADING">
      <div class="wide-container">
        <EventFormSection :card="false" wide>
          <div slot="section-content">
            <v-container>
              <EventFormSection :card="false" wide compact>
                <div slot="section-content">
                  <v-row>
                    <v-col cols="12" md="6">
                      <label class="event-link">Event ID: </label>
                      {{ CURRENT_EVENT_OBJECT.id }}
                    </v-col>
                    <v-col cols="12" md="6">
                      <label class="event-link">Event Status: </label>
                      {{ eventStatusTitle }}
                    </v-col>
                  </v-row>
                  <v-row v-if="!isBatchEvent">
                    <v-col cols="12" md="6">
                      <label class="event-link">Public Event URL: </label>
                      <v-skeleton-loader
                        v-if="!BITLY_LINK"
                        class="bitly-skeleton"
                        max-width="300"
                        type="text"
                      ></v-skeleton-loader>
                      <a :href="BITLY_LINK" target="_blank">{{ BITLY_LINK }}</a>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="
                        CURRENT_EVENT_OBJECT.contestType ===
                          'Enter for a Chance to Win'
                      "
                    >
                      <label class="event-link">
                        Public Rules URL:
                      </label>
                      <router-link
                        :to="'/event/rules/' + $route.params.id"
                        target="_blank"
                      >
                        {{
                          urlRoot + '/#/event/rules/' + CURRENT_EVENT_OBJECT.id
                        }}
                      </router-link>
                      <div class="mt-2">
                        <template v-if="CURRENT_EVENT_OBJECT.eventLanguage === 'bi'">
                          <v-btn
                            class="mb-2"
                            color="primary"
                            elevation="2"
                            block
                            x-large
                            @click="downloadRulesPDF('en')"
                          >
                            Download English Rules PDF
                          </v-btn>
                          <v-btn
                            color="primary"
                            elevation="2"
                            block
                            x-large
                            @click="downloadRulesPDF('es')"
                          >
                            Download Spanish Rules PDF
                          </v-btn>
                        </template>
                        <template v-else>
                          <v-btn
                            color="primary"
                            elevation="2"
                            block
                            x-large
                            @click="downloadRulesPDF('en')"
                          >
                            Download Rules PDF
                          </v-btn>
                        </template>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="CURRENT_EVENT_OBJECT.status === 'Denied'"
                    >
                      <label class="event-link">Denied Reason: </label>
                      {{
                        CURRENT_LEGAL_OBJECT
                          ? CURRENT_LEGAL_OBJECT.legal_message
                          : ''
                      }}
                    </v-col>
                    <v-col v-show="event_code" cols="12">
                      <label class="event-link">Access Code:</label>
                      <p>
                        {{ event_code }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
              </EventFormSection>
            </v-container>
          </div>
        </EventFormSection>
      </div>

      <v-row justify="center" class="my-0">
        <v-col cols="9">
          <v-expansion-panels>
            <v-expansion-panel :active-class="'active'">
              <v-expansion-panel-header style="background:black;color:white;">
                <span>Event History </span>
                <template v-slot:actions>
                  <v-icon x-large color="primary">
                    $expand
                  </v-icon>
                </template>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <PastelTable
                  class="my-4"
                  :rows="HISTORY_TABLE_DATA"
                  :columns="[
                    {
                      source: 'type',
                      label: 'Transaction Type'
                    },
                    {
                      source: 'action',
                      label: 'Transaction Action'
                    },
                    {
                      source: 'timestamp',
                      label: 'Timestamp'
                    },
                    {
                      source: 'description',
                      label: 'Description'
                    },
                    {
                      source: 'user',
                      label: 'User'
                    }
                  ]"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </div>
    <!-- {{ CURRENT_EVENT_OBJECT }} -->
    <template v-if="!LOADING">
      <EventEditorForm :is-mobile="isMobile" :is-edit-form="true" ref="form">
        <template v-slot:screenbuttons>
          <div class="form-buttons" v-if="!hideAllFormButtons">
            <v-row justify="center">
              <v-col cols="10" md="6">
                <v-btn
                  elevation="2"
                  tile
                  block
                  x-large
                  color="primary"
                  outlined
                  class="exit-button"
                  @click="exitPage"
                >
                  <span class="black--text button-text">
                    Exit
                  </span>
                </v-btn>
              </v-col>
            </v-row>

            <v-row
              justify="center"
              v-if="
                IS_DEVELOPER ||
                  (['Legal Pending', 'Draft'].includes(CURRENT_EVENT_OBJECT.status) &&
                    !publishedAndStarted &&
                    showUpdateButton &&
                    !CURRENT_EVENT_OBJECT.archived)
              "
            >
              <v-col cols="10" md="6">
                <v-btn
                  elevation="2"
                  tile
                  outlined
                  block
                  x-large
                  color="primary"
                  :loading="API_CALL_IN_PROGRESS"
                  :disabled="!UNTRACKED_CHANGES_TO_EVENT"
                  @click="updateDraftEvent"
                >
                  <span class="black--text button-text">
                    Update Draft
                  </span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              justify="center"
              v-if="canDeleteEvent"
            >
              <v-col cols="10" md="6">
                <v-btn
                  elevation="2"
                  tile
                  block
                  x-large
                  color="primary"
                  outlined
                  :disabled="!!CURRENT_EVENT_OBJECT.archived"
                  :loading="API_CALL_IN_PROGRESS"
                  @click="showDeleteEvent = true"
                >
                  <span class="black--text button-text">
                    Delete Event
                  </span>
                </v-btn>
              </v-col>
            </v-row>

            <v-row
              justify="center"
              v-if="canPauseLegalReview"
            >
              <v-col cols="10" md="6">
                <v-btn
                  elevation="2"
                  tile
                  block
                  x-large
                  color="primary"
                  outlined
                  :loading="API_CALL_IN_PROGRESS"
                  @click="pauseLegalAction"
                >
                  <span class="black--text button-text">
                    Pause Legal Review
                  </span>
                </v-btn>
              </v-col>
            </v-row>

            <v-row
              justify="center"
              v-if="canPauseTranslate"
            >
              <v-col cols="10" md="6">
                <v-btn
                  elevation="2"
                  tile
                  block
                  x-large
                  outlined
                  color="primary"
                  :loading="API_CALL_IN_PROGRESS"
                  @click="pauseTranslationAction"
                >
                  <span class="black--text button-text">
                    Pause Translation
                  </span>
                </v-btn>
              </v-col>
            </v-row>

            <v-row
              justify="center"
              v-show="
                (!publishedAndStarted &&
                  (CURRENT_EVENT_OBJECT.status === 'Draft' ||
                    CURRENT_EVENT_OBJECT.status == 'Denied')) ||
                  (CURRENT_EVENT_OBJECT.status === 'Published' &&
                    showUpdateButton &&
                    !CURRENT_EVENT_OBJECT.archived)
              "
            >
              <v-col cols="10" md="6">
                <v-btn
                  elevation="2"
                  tile
                  block
                  x-large
                  :loading="API_CALL_IN_PROGRESS"
                  :color="
                    CURRENT_EVENT_OBJECT.published ? 'primary' : 'secondary'
                  "
                  :disabled="
                    validateSubmitToLegal.length > 0 ||
                      (CURRENT_EVENT_OBJECT.status === 'Published' &&
                        !UNTRACKED_CHANGES_TO_EVENT)
                  "
                  @click="submitToLegalReview"
                >
                  <span class="white--text button-text">
                    Submit to Legal
                  </span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center" v-if="isBatchEvent">
              <v-col cols="10" md="6">
                <v-btn
                  elevation="2"
                  tile
                  block
                  x-large
                  :loading="API_CALL_IN_PROGRESS"
                  :color="
                    CURRENT_EVENT_OBJECT.published ? 'primary' : 'secondary'
                  "
                  :disabled="
                    validateSubmitBatchEvent.length > 0 ||
                      !UNTRACKED_CHANGES_TO_EVENT
                  "
                  @click="submitBatchEvent"
                >
                  <span class="white--text button-text">
                    Submit
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>
      </EventEditorForm>
    </template>
    <template v-else>
      <div
        style="height:100%;width:100%;display:flex;justify-content:center;"
        class="text-center"
      >
        <v-progress-circular indeterminate color="red" />
      </div>
    </template>
    <v-dialog
      v-model="showDeleteEvent"
      width="600"
      content-class="app-modal-dialog">
      <v-card class="pa-8">
        <v-card-title class="justify-center grey lighten-2">
          Delete Event
        </v-card-title>

        <v-card-text>
          Are you sure you want to delete this event?
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center pt-8">
          <v-btn
            @click="showDeleteEvent = false"
            text
            class="px-6 btn__secondary"
          >
            No
          </v-btn>
          <v-btn @click="deleteEvent" text class="px-6 btn__primary">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" width="600" content-class="app-modal-dialog">
      <v-card class="pa-8">
        <v-card-title class="justify-center grey lighten-2">
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text class="mt-2 text-center">
          {{ dialogMessage }}
          <ul style="list-style: none; padding-left: 0;">
            <li v-for="error in validateDraftEvtObj" :key="error.id">
              {{ error }}
            </li>
            <li v-for="error in currentFormErrors" :key="error.id">
              {{ error }}
            </li>
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center pt-8">
          <v-btn @click="dialogAction" text class="px-6 btn__primary">
            {{ dialogActionText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invalidEntryPeriodDialogue"
      width="600"
      content-class="app-modal-dialog"
    >
      <v-card class="pa-8">
        <v-card-title class="justify-center grey lighten-2">
          Invalid Fields
        </v-card-title>

        <v-card-text class="mt-2 text-center">
          <ul style="list-style: none; padding-left: 0;">
            <li v-for="error in invalidIntervalArr" :key="error.id">
              {{
                `Please Fix entry period ${error.index + 1} :  ${error.message}`
              }}
            </li>
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center pt-8">
          <v-btn
            @click="invalidEntryPeriodDialogue = false"
            text
            class="px-6 btn__primary"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="successDialog"
      width="600"
      content-class="app-modal-dialog"
    >
      <v-card class="pa-8">
        <v-card-title class="justify-center grey lighten-2">
          {{ successDialogTitle || 'Event Updated' }}
        </v-card-title>

        <v-card-text class="mt-2 text-center">
          {{ successDialogMessage }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center pt-8">
          <v-btn @click="returnToDash" text class="px-6 btn__secondary">
            Dashboard
          </v-btn>
          <v-btn @click="resetSuccessDialog" text class="px-6 btn__primary">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="errorDialog"
      width="600"
      content-class="app-modal-dialog"
    >
      <v-card class="pa-8">
        <v-card-title class="justify-center grey lighten-2">
          Error
        </v-card-title>

        <v-card-text class="mt-2 text-center">
          There was an error fetching that event. Please try again later.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center pt-8">
          <v-btn @click="returnToDash" text class="px-6 btn__primary">
            Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="untrackedChangesDialog"
      width="600"
      content-class="app-modal-dialog"
    >
      <v-card class="pa-8">
        <v-card-title class="justify-center grey lighten-2">
          Unsaved Changes
        </v-card-title>

        <v-card-text class="mt-2 text-center">
          You have unsaved changes to your event. Would you like to save your
          changes before leaving?
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center pt-8">
          <v-btn
            @click="continueWithoutSavingEvent"
            text
            class="px-6 btn__secondary"
          >
            Exit without saving
          </v-btn>
          <v-btn @click="continueEditingEvent" text class="px-6 btn__primary">
            Keep editing
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AlertBar from '@/components/AlertBar.vue';
import BannerTitle from '@/components/BannerTitle.vue';
// import CreateEventForm from '@/components/EventForm/CreateEventForm.vue';
import EventEditorForm from '@/components/Forms/EventEditorForm.vue';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import ThemeSwitcher from '@/utility/ThemeSwitcher';
import EventActionBar from '@/components/EventForm/EventActionBar.vue';
import EventActionOverlay from '@/components/EventForm/EventActionOverlay.vue';
import EventFormSection from '@/components/EventForm/EventFormSection';
import { TrackUnsavedChangesDialogControl } from '@/mixins/TrackUnsavedChangesDialogControl';
import {
  SubmitToLegalEventSchema,
  DraftEventSchema,
  EnterToWinEventSchema,
  BatchImportEventSchema
} from '@/utility/ValidationSchemas';
import { DateTime } from 'luxon';
import { validateEventDates } from '@/utility/ValidateEventDates';
import PastelTable from '@/components/PastelTable.vue';
import jsPDF from 'jspdf';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

const validate = (object, schema) =>
  Object.keys(schema)
    .filter(key => !schema[key](object[key]))
    .map(key => new Error(`${key} is invalid.`));

export default {
  name: 'EventEdit',
  mixins: [TrackUnsavedChangesDialogControl],
  components: {
    AlertBar,
    BannerTitle,
    EventActionBar,
    EventEditorForm,
    EventActionOverlay,
    EventFormSection,
    PastelTable
  },
  async mounted() {
    try {
      this.$store.commit('EVENT_MANAGER_STORE/RESET_ALL');
      await this.fetchEventData();
      this.onResize();
      window.addEventListener('resize', this.onResize, { passive: true });

      if (this.isBatchEvent && !this.IS_ADMIN) {
        // only admins can edit batch import events
        this.$router.push('/dashboard');
      }
      this.onResize();

      //Setup the temp values for translations;
      this.tempEventName = this.CURRENT_EVENT_OBJECT.name;
      this.tempPrizeDescription = this.CURRENT_EVENT_OBJECT.fullPrizeDescription;
      this.tempAbbreviatedPrizeDescription = this.CURRENT_EVENT_OBJECT.abbreviatedPrizeDescription;
      this.tempSweepstakesTitle = this.CURRENT_EVENT_OBJECT.sweepstakesTitle;
      this.tempAbbreviatedLegal = this.CURRENT_EVENT_OBJECT.abbreviatedLegal;

      let historyPayload = {
        eventId: this.$route.params.id,
        timezone: this.CURRENT_EVENT_OBJECT.timezone || 'America/New_York'
      };
      await this.GET_ALL_HISTORY(historyPayload);
    } catch (e) {
      console.log(e);
      //Display Error dialog
      this.errorDialog = true;
    }
  },
  data() {
    return {
      isMobile: false,
      loaded: false,
      curAction: null,
      temporaryEventObject: {},
      publishedAndStarted: false,
      showUpdateButton: false,
      dialog: false,
      dialogTitle: '',
      dialogMessage: '',
      dialogActionText: '',
      dialogAction: null,
      successDialog: false,
      successDialogTitle: null,
      successDialogMessage: null,
      showSuccessDialog: false,
      //Used for translations;
      tempEventName: null,
      tempPrizeDescription: null,
      tempAbbreviatedPrizeDescription: null,
      tempSweepstakesTitle: null,
      tempAbbreviatedLegal: null,
      //End used for translations;
      errorDialog: false,
      invalidIntervalArr: [],
      currentFormErrors: [],
      invalidEntryPeriodDialogue: false,
      untrackedChangesDialog: false,
      targetToRoute: false,
      showDeleteEvent: false,
    };
  },

  watch: {
    $route() {
      this.fetchEventData();
    },
    brandWatcher: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.changeTheme(newVal);
        }
      }
    },
    CURRENT_EVENT_OBJECT: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.handleScreenSetup(newVal);
        }
      }
    }
  },
  methods: {
    async fetchEventData() {
      try {
        let evtId = this.$route.params.id;
        let evtGet = await this.$store.dispatch(
          'EVENT_MANAGER_STORE/LOAD_EVENT',
          evtId
        );

        this.changeTheme(this.brandWatcher);

        if (this.CURRENT_EVENT_OBJECT.status === 'Published') {
          this.temporaryEventObject = this.CURRENT_EVENT_OBJECT;
        }

        await this.$store.dispatch(
          'EVENT_MANAGER_STORE/FETCH_BITLY_LINK',
          evtId
        );
        await this.$store.dispatch('AVE_CANVAS_STORE/GET_AVAILABLE_IMAGES');
        await this.$store.dispatch('LEGAL_STORE/FETCH_LEGAL', evtId);
        await this.GET_PROXIES(this.$route.params.id);
      } catch (error) {
        console.log(error);
        //Display Error dialog
        this.errorDialog = true;
      }
    },
    ...mapMutations({
      UPDATE_TRANSLATION_PROPERTY: 'UPDATE_TRANSLATION_PROPERTY'
    }),
    ...mapActions({
      sendEmail: 'admin/sendEmail',
      approveTranslations: 'approveTranslations',
      fetchTranslations: 'fetchTranslations'
    }),
    ...mapActions('PROXY_STORE', ['GET_PROXIES']),
    ...mapActions('EVENT_HISTORY_STORE', ['GET_ALL_HISTORY']),
    returnToDash() {
      this.$store.commit('EVENT_MANAGER_STORE/RESET_ALL');
      this.$router.push({ path: '/dashboard' });
    },
    exitPage() {
      this.$store.commit('EVENT_MANAGER_STORE/RESET_ALL');
      this.$router.push({ path: '/dashboard' });
    },
    resetSuccessDialog() {
      this.successDialog = false;
      this.successDialogMessage = null;
      this.successDialogTitle = null;
    },
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
    changeTheme(brand) {
      ThemeSwitcher.ChangeTheme(this, brand);
    },
    validateEventDatesWrapper() {
      validateEventDates(
        this.CURRENT_EVENT_OBJECT,
        this.currentFormErrors,
        this.invalidIntervalArr,
        this.$store,
        {
          isAdmin: this.IS_ADMIN,
          isDeveloper: this.IS_DEVELOPER
        }
      );
    },
    validateLegalAndLocation() {
      // validate abbreviated legal
      if (
        this.CURRENT_EVENT_OBJECT.legalRequired &&
        !this.CURRENT_EVENT_OBJECT.standardAbbreviatedRules &&
        !this.CURRENT_EVENT_OBJECT.abbreviatedLegal
      ) {
        this.currentFormErrors.push(
          'You must provide legal language if you have indicated your event needs it.'
        );
      }
      if (
        this.CURRENT_EVENT_OBJECT.contestType === 'Enter for a Chance to Win' &&
        !this.CURRENT_EVENT_OBJECT.legalRequired
      ) {
        if (!this.CURRENT_EVENT_OBJECT.sweepstakesTitle)
          this.currentFormErrors.push('Sweepstakes title is required.');
        if (!this.CURRENT_EVENT_OBJECT.fullPrizeDescription)
          this.currentFormErrors.push('Full prize description is required.');
        if (!this.CURRENT_EVENT_OBJECT.arv)
          this.currentFormErrors.push('ARV is required.');
      }
      // validate event location
      if (
        this.CURRENT_EVENT_OBJECT.region !== 'National' &&
        !this.CURRENT_EVENT_OBJECT.state
      ) {
        this.currentFormErrors.push('State is required.');
      }
      if (this.CURRENT_EVENT_OBJECT.eventLocation === 'Online/Virtual Event') {
        if (!this.CURRENT_EVENT_OBJECT.region) {
          this.currentFormErrors.push('Region is required.');
        }
        if (this.CURRENT_EVENT_OBJECT.region !== 'National') {
          if (!this.CURRENT_EVENT_OBJECT.dma)
            this.currentFormErrors.push('DMA is required.');
        }
      } else {
        if (!this.CURRENT_EVENT_OBJECT.physicalEventAddress)
          this.currentFormErrors.push('Event Address is required.');
        if (!this.CURRENT_EVENT_OBJECT.physicalEventCity)
          this.currentFormErrors.push('Event City is required.');
        if (!this.CURRENT_EVENT_OBJECT.physicalEventZip)
          this.currentFormErrors.push('Event Zip is required.');
      }
    },
    handleScreenSetup(eventObject) {
      this.publishedAndStarted = false;
      //Handle all of the setup steps;
      let todaysDate = new Date().valueOf(),
        formattedStartDate = null;
      //Handle published and started;
      let {
        published = false,
        eventStartDate = null,
        archived = false
      } = eventObject;
      if (eventStartDate) {
        formattedStartDate = DateTime.fromISO(eventStartDate);
      }
      //Check if the event is published and running;
      if (published && formattedStartDate) {
        let isEventStarted = formattedStartDate < todaysDate;
        let isEventWithin24Hours =
          Math.abs((formattedStartDate - todaysDate) / 1000 / 3600) < 24;
        if (!this.isBatchEvent) {
          if (isEventStarted || (!(this.IS_ADMIN || this.IS_DEVELOPER) && isEventWithin24Hours)) {
            this.publishedAndStarted = true;
            this.displayDialog(
              'Event cannot be updated',
              'Published events are locked to updates 1 day before their start date.',
              'Close',
              () => (this.dialog = false)
            );
          }
        }
      }
      //Check if we should be showing the Update button;
      if (this.IS_ADMIN && formattedStartDate && !archived) {
        this.showUpdateButton = todaysDate < formattedStartDate;
      } else if (!archived && formattedStartDate) {
        let startDateMinusOne = formattedStartDate.minus({ days: 1 });
        this.showUpdateButton = todaysDate < startDateMinusOne.valueOf();
      }
      if (this.isBatchEvent) {
        this.showUpdateButton = false;
      }
      if (this.CURRENT_EVENT_OBJECT.status === 'Draft' && !archived) {
        this.showUpdateButton = true;
      }
    },
    async updateDraftEvent() {
      try {
        this.currentFormErrors = [];
        if (this.validateDraftEvtObj.length > 0) {
          this.currentFormErrors.push(
            'One or more of your fields are invalid. Please fix these fields before proceeding.'
          );
        }
        this.validateEventDatesWrapper();
        if (this.currentFormErrors.length > 0) {
          this.displayDialog('Invalid Fields', '', 'Close', () => {
            this.dialog = false;
          });
          return;
        }
        if (this.invalidIntervalArr.length > 0) {
          this.invalidEntryPeriodDialogue = true;
          return;
        }
        if (this.CURRENT_EVENT_OBJECT.isTranslated) {
          this.updateForTranslation();
        }

        //Update the event Status;
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: 'Draft'
        });

        //Send draft email or show dialog
        let newEventId = await this.$store.dispatch(
          'EVENT_MANAGER_STORE/PATCH_EVENT',
          this.$route.params.id
        );
        let { id = null } = newEventId;

        //RELOAD the event
        if (id) {
          await this.$store.dispatch('EVENT_MANAGER_STORE/LOAD_EVENT', id);
          this.newEventId = id;
          this.successDialogTitle = 'Draft Updated';
          this.successDialogMessage =
            'Draft Updated. Would you like to continue editing or return to the main dashboard?';
          this.successDialog = true;
        } else {
          let error = newEventId.errorMessage || newEventId.message;
          throw error;
        }
      } catch (error) {
        this.dialogTitle = 'Error';
        this.dialogMessage =
          error ||
          'We are experiencing unusually high traffic at this time, please try to save your event again or contact us if this continues occuring.';
        this.dialogActionText = 'Close';
        this.dialogAction = () => {
          this.dialog = false;
        };
        return (this.dialog = true);
      }
    },
    async pauseTranslationAction() {
      let oldStatus = this.CURRENT_EVENT_OBJECT.status;
      try {
        this.currentFormErrors = [];
        if (this.validateDraftEvtObj.length > 0) {
          this.currentFormErrors.push(
            'One or more of your fields are invalid. Please fix these fields before proceeding.'
          );
        }
        this.validateEventDatesWrapper();
        if (this.currentFormErrors.length > 0) {
          this.displayDialog('Invalid Fields', '', 'Close', () => {
            this.dialog = false;
          });
          return;
        }
        if (this.invalidIntervalArr.length > 0) {
          this.invalidEntryPeriodDialogue = true;
          return;
        }
        //Update the event Status;
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: 'Draft'
        });

        let newEventId = await this.$store.dispatch(
          'EVENT_MANAGER_STORE/PATCH_EVENT',
          this.$route.params.id
        );
        let { id = null } = newEventId;
        if (id) {
          this.newEventId = id;
          //Send email;
          let eventName = this.CURRENT_EVENT_OBJECT.name;

          this.sendEmail(
            this.pauseTranslationEmail(
              `${process.env.VUE_APP_TRANSLATION_TO_EMAIL},${process.env.VUE_APP_MANAGER_TO_EMAIL}`,
              eventName
            )
          );
          this.sendEmail(
            this.userEventPauseEmail(
              this.CURRENT_EVENT_OBJECT.createdByEmail,
              eventName
            )
          );

          //RELOAD the event
          await this.$store.dispatch('EVENT_MANAGER_STORE/LOAD_EVENT', id);
          this.successDialogTitle = 'Translation Paused';
          this.successDialogMessage =
            'The translation process is paused. Would you like to continue editing or return to the main dashboard?';
          this.successDialog = true;
        } else {
          let error = newEventId.errorMessage || newEventId.message;
          throw error;
        }
      } catch (error) {
        // revert status
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: oldStatus
        });
        this.dialogTitle = 'Error';
        this.dialogMessage =
          error ||
          'We are experiencing unusually high traffic at this time, please try to save your event again or contact us if this continues occuring.';
        this.dialogActionText = 'Close';
        this.dialogAction = () => {
          this.dialog = false;
        };
        return (this.dialog = true);
      }

      // send translation pause email
    },
    async updateForTranslation() {
      try {
        let evtId = this.$route.params.id;
        if (
          this.tempEventName != this.CURRENT_EVENT_OBJECT.name ||
          this.tempAbbreviatedPrizeDescription !=
          this.CURRENT_EVENT_OBJECT.abbreviatedPrizeDescription ||
          this.CURRENT_EVENT_OBJECT.abbreviatedLegal !=
          this.tempAbbreviatedLegal ||
          this.CURRENT_EVENT_OBJECT.fullPrizeDescription !=
          this.tempPrizeDescription ||
          this.CURRENT_EVENT_OBJECT.sweepstakesTitle !=
          this.tempSweepstakesTitle
        ) {
          await this.$store.commit(
            'EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY',
            {
              key: 'isTranslated',
              value: 0
            }
          );
          await this.fetchTranslations(evtId);
          if (this.tempEventName != this.CURRENT_EVENT_OBJECT.name) {
            await this.$store.commit('UPDATE_TRANSLATION_PROPERTY', {
              key: 'name',
              value: null
            });
          }
          if (
            this.tempAbbreviatedLegal !=
            this.CURRENT_EVENT_OBJECT.abbreviatedLegal
          ) {
            await this.$store.commit('UPDATE_TRANSLATION_PROPERTY', {
              key: 'abbreviatedLegal',
              value: null
            });
          }

          if (
            this.tempAbbreviatedPrizeDescription !=
            this.CURRENT_EVENT_OBJECT.abbreviatedPrizeDescription
          ) {
            await this.$store.commit('UPDATE_TRANSLATION_PROPERTY', {
              key: 'abbreviatedPrizeDescription',
              value: null
            });
          }
          if (
            this.tempPrizeDescription !=
            this.CURRENT_EVENT_OBJECT.fullPrizeDescription
          ) {
            await this.$store.commit('UPDATE_TRANSLATION_PROPERTY', {
              key: 'fullPrizeDescription',
              value: null
            });
          }
        }
        await this.approveTranslations(evtId);
        //Update the event Status;
      } catch (error) {
        this.dialogTitle = 'Error';
        this.dialogMessage =
          error ||
          'We are experiencing unusually high traffic at this time, please try to save your event again or contact us if this continues occuring.';
        this.dialogActionText = 'Close';
        this.dialogAction = () => {
          this.dialog = false;
        };
        return (this.dialog = true);
      }
    },
    async pauseLegalAction() {
      let oldStatus = this.CURRENT_EVENT_OBJECT.status;
      try {
        this.currentFormErrors = [];
        if (this.validateDraftEvtObj.length > 0) {
          this.currentFormErrors.push(
            'One or more of your fields are invalid. Please fix these fields before proceeding.'
          );
        }
        this.validateEventDatesWrapper();
        if (this.currentFormErrors.length > 0) {
          this.displayDialog('Invalid Fields', '', 'Close', () => {
            this.dialog = false;
          });
          return;
        }
        if (this.invalidIntervalArr.length > 0) {
          this.invalidEntryPeriodDialogue = true;
          return;
        }
        //Update the event Status;
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: 'Draft'
        });

        //Send draft email or show dialog
        let newEventId = await this.$store.dispatch(
          'EVENT_MANAGER_STORE/PATCH_EVENT',
          this.$route.params.id
        );
        let { id = null } = newEventId;

        //RELOAD the event
        if (id) {
          await this.$store.dispatch('EVENT_MANAGER_STORE/LOAD_EVENT', id);
          this.newEventId = id;
          //Send the email to legal;
          let eventName = this.CURRENT_EVENT_OBJECT.name;
          this.sendEmail(
            this.pauseLegalReviewEmail(
              process.env.VUE_APP_LEGAL_TO_EMAIL,
              eventName
            )
          );
          this.sendEmail(
            this.userEventPauseEmail(
              this.CURRENT_EVENT_OBJECT.createdByEmail,
              eventName
            )
          );

          this.successDialogTitle = 'Legal Review Paused';
          this.successDialogMessage =
            'The legal review process is paused. Would you like to continue editing or return to the main dashboard?';
          this.successDialog = true;
        } else {
          let error = newEventId.errorMessage || newEventId.message;
          throw error;
        }
      } catch (error) {
        // revert status
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: oldStatus
        });
        this.dialogTitle = 'Error';
        this.dialogMessage =
          error ||
          'We are experiencing unusually high traffic at this time, please try to save your event again or contact us if this continues occuring.';
        this.dialogActionText = 'Close';
        this.dialogAction = () => {
          this.dialog = false;
        };
        return (this.dialog = true);
      }
    },
    async submitToLegalReview() {
      let oldStatus = this.CURRENT_EVENT_OBJECT.status;
      try {
        this.currentFormErrors = [];
        // highlight errors
        this.$refs.form.validate();
        if (this.validateSubmitToLegal.length > 0) {
          this.currentFormErrors.push(
            'One or more of your fields are invalid. Please fix these fields before proceeding.'
          );
        }
        this.validateEventDatesWrapper();
        this.validateLegalAndLocation();
        if (this.currentFormErrors.length > 0) {
          this.displayDialog('Invalid Fields', '', 'Close', () => {
            this.dialog = false;
          });
          return;
        }
        if (this.invalidIntervalArr.length > 0) {
          this.invalidEntryPeriodDialogue = true;
          return;
        }
        if (this.CURRENT_EVENT_OBJECT.isTranslated) {
          this.updateForTranslation();
        }

        //Update the event Status;
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: 'Legal Pending'
        });

        let newEventId = await this.$store.dispatch(
          'EVENT_MANAGER_STORE/PATCH_EVENT',
          this.$route.params.id
        );
        let { id = null } = newEventId;
        if (id) {
          this.newEventId = id;
          //Send Email;
          let eventName = this.CURRENT_EVENT_OBJECT.name;
          this.sendEmail(
            this.legalReviewEmail(process.env.VUE_APP_LEGAL_TO_EMAIL, eventName)
          );
          this.sendEmail(
            this.userEventSubmittedLegalEmail(
              this.CURRENT_EVENT_OBJECT.createdByEmail,
              eventName
            )
          );

          //RELOAD the event
          await this.$store.dispatch('EVENT_MANAGER_STORE/LOAD_EVENT', id);
          this.successDialogTitle = 'Legal Review';
          this.successDialogMessage =
            'Your Event has been submitted to legal for review. Would you like to continue editing or return to the main dashboard?';
          this.successDialog = true;
        } else {
          let error = newEventId.errorMessage || newEventId.message;
          throw error;
        }
      } catch (error) {
        // revert status
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: oldStatus
        });
        this.dialogTitle = 'Error';
        this.dialogMessage =
          error ||
          'We are experiencing unusually high traffic at this time, please try to save your event again or contact us if this continues occuring.';
        this.dialogActionText = 'Close';
        this.dialogAction = () => {
          this.dialog = false;
        };
        return (this.dialog = true);
      }
    },
    async submitBatchEvent() {
      try {
        if (this.validateSubmitBatchEvent.length > 0) {
          this.dialogTitle = 'Invalid Fields';
          this.dialogMessage =
            'One or more of your fields are invalid. Please fix these fields before proceeding.';
          this.dialogActionText = 'Close';
          this.dialogAction = () => {
            this.dialog = false;
          };
          return (this.dialog = true);
        }

        // make sure that event end time >= start time
        if (this.eventEndsBeforeItStarts()) {
          this.dialogTitle = 'Invalid Fields';
          this.dialogMessage =
            'Event end time cannot be before event start time.';
          this.dialogActionText = 'Close';
          this.dialogAction = () => {
            this.dialog = false;
          };
          return (this.dialog = true);
        }

        //Update the event Status;
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'status',
          value: 'Published'
        });
        await this.$store.commit('EVENT_MANAGER_STORE/UPDATE_EVENT_PROPERTY', {
          key: 'published',
          value: '1'
        });

        let newEventId = await this.$store.dispatch(
          'EVENT_MANAGER_STORE/PATCH_EVENT',
          this.$route.params.id
        );
        let { id = null } = newEventId;

        //RELOAD the event
        if (id) {
          await this.$store.dispatch('EVENT_MANAGER_STORE/LOAD_EVENT', id);
          this.newEventId = id;
          this.successDialogTitle = 'Success';
          this.successDialogMessage =
            'Your Event has been published. Would you like to continue editing or return to the main dashboard?';
          this.successDialog = true;
        } else {
          let error = newEventId.errorMessage || newEventId.message;
          throw error;
        }
      } catch (error) {
        this.dialogTitle = 'Error';
        this.dialogMessage =
          error ||
          'We are experiencing unusually high traffic at this time, please try to save your event again or contact us if this continues occuring.';
        this.dialogActionText = 'Close';
        this.dialogAction = () => {
          this.dialog = false;
        };
        return (this.dialog = true);
      }
    },
    scrollToWinners() {
      this.$refs.winnerFields.scrollToWinners();
    },
    displayDialog(title, message, actionText, action) {
      this.dialogTitle = title;
      this.dialogMessage = message;
      this.dialogActionText = actionText;
      this.dialogAction = action;
      this.dialog = true;
    },
    //Emails Start
    legalReviewEmail(toAddress, eventName) {
      let eventStartDate = `${this.CURRENT_EVENT_OBJECT.startDate} ${this.CURRENT_EVENT_OBJECT.startTime}`;
      let eventEndDate = `${this.CURRENT_EVENT_OBJECT.endDate} ${this.CURRENT_EVENT_OBJECT.endTime}`;
      let given_name = this.CURRENT_EVENT_OBJECT.createdByFirstName;
      let family_name = this.CURRENT_EVENT_OBJECT.createdByLastName;
      let email = this.CURRENT_EVENT_OBJECT.createdByEmail;
      let legalDetails = this.CURRENT_EVENT_OBJECT.legalDetails;
      let contract = this.CURRENT_EVENT_OBJECT.legalContract
        ? this.CURRENT_EVENT_OBJECT.legalContract
        : 'N/A';

      let templateData = {
        preheader_text: '',
        header_text: 'T-Mobile Engagement Hub Event Review',
        greeting_text: `Hi, Legal Team,`,
        'body-1_text':
          'An event is ready to be reviewed for legal approval. Click the button below to review the event details.',
        'cta-1_href':
          'https://www.t-mobileengagementhub.com/#/legal/' +
          this.$route.params.id,
        'cta-1_text': 'Review Event',
        'body-2_text': `
          Event Name: ${eventName}<br>
          Event Start Date: ${eventStartDate}<br>
          Event End Date: ${eventEndDate}<br>
          Event Created by: ${given_name} ${family_name}; ${email}<br>
          Needs Translation: ${!this.CURRENT_EVENT_OBJECT.isTranslated && this.CURRENT_EVENT_OBJECT.eventLanguage === 'bi' ? 'yes' : 'no'}<br>
          Legal Details: ${legalDetails}<br>
          Contract, if provided: ${contract}<br>
        `,
        subject_text:
          'Legal Review Request for Event ID: ' + this.$route.params.id,
        'text-part_text': ''
      };
      let emailTemplate = {
        Source: 'Legal Review <donotreply@t-mobileengagementhub.com>',
        Template: 'one-cta-template',
        ConfigurationSetName: 'ConfigSet',
        Destination: {
          ToAddresses: toAddress?.split(',') ?? [],
        },
        TemplateData: JSON.stringify(templateData, null, 2)
      };
      return emailTemplate;
    },
    async deleteEvent() {
      this.showDeleteEvent = false;

      await this.$store.dispatch(
        'EVENT_MANAGER_STORE/DELETE_EVENT',
        this.$route.params.id
      );

      this.returnToDash();
    },
    userEventSubmittedLegalEmail(toAddress, eventName) {
      let eventId = this.$route.params.id;
      let eventStartDate = `${this.CURRENT_EVENT_OBJECT.startDate} ${this.CURRENT_EVENT_OBJECT.startTime}`;
      let eventEndDate = `${this.CURRENT_EVENT_OBJECT.endDate} ${this.CURRENT_EVENT_OBJECT.endTime}`;
      let given_name = this.CURRENT_EVENT_OBJECT.createdByFirstName;
      let family_name = this.CURRENT_EVENT_OBJECT.createdByLastName;
      let email = this.CURRENT_EVENT_OBJECT.createdByEmail;
      let legalDetails = this.CURRENT_EVENT_OBJECT.legalDetails;
      let contract = this.CURRENT_EVENT_OBJECT.legalContract
        ? this.CURRENT_EVENT_OBJECT.legalContract
        : 'N/A';

      let templateData = {
        preheader_text: '',
        header_text: 'T-Mobile Engagement Hub Legal Review Request',
        greeting_text: `Greetings,`,
        'body-1_text': 'Your event has been sent to be reviewed by legal.',
        'body-2_text':
          'Event Name: ' +
          eventName +
          '<br>' +
          'Event Start Date: ' +
          eventStartDate +
          '<br>' +
          'Event End Date: ' +
          eventEndDate +
          '<br>' +
          'Event Created by: ' +
          given_name +
          ' ' +
          family_name +
          '; ' +
          email +
          '<br>' +
          'Legal Details: ' +
          legalDetails +
          '<br>' +
          'Contract, if provided: ' +
          contract,
        subject_text: 'Legal Review Request Receipt for Event ID: ' + eventId,
        'text-part_text': ''
      };
      let emailTemplate = {
        Source:
          'Legal Review Submission <donotreply@t-mobileengagementhub.com>',
        Template: 'no-cta-template',
        ConfigurationSetName: 'ConfigSet',
        Destination: {
          ToAddresses: [`${toAddress}`]
        },
        TemplateData: JSON.stringify(templateData, null, 2)
      };
      return emailTemplate;
    },
    pauseLegalReviewEmail(toAddress, eventName) {
      let eventId = this.$route.params.id;
      let eventStartDate = `${this.CURRENT_EVENT_OBJECT.startDate} ${this.CURRENT_EVENT_OBJECT.startTime}`;
      let eventEndDate = `${this.CURRENT_EVENT_OBJECT.endDate} ${this.CURRENT_EVENT_OBJECT.endTime}`;
      let given_name = this.CURRENT_EVENT_OBJECT.createdByFirstName;
      let family_name = this.CURRENT_EVENT_OBJECT.createdByLastName;
      let email = this.CURRENT_EVENT_OBJECT.createdByEmail;
      let legalDetails = this.CURRENT_EVENT_OBJECT.legalDetails;
      let contract = this.CURRENT_EVENT_OBJECT.legalContract
        ? this.CURRENT_EVENT_OBJECT.legalContract
        : 'N/A';

      let templateData = {
        preheader_text: '',
        header_text: 'Legal Review Paused',
        greeting_text: `Hi, Legal Team,`,
        'body-1_text':
          'An event that had previously been submitted for review is currently being edited. You will not be able to complete legal review on the event listed below until it is re-submitted for approval.',
        'body-2_text':
          'Event Name: ' +
          eventName +
          '<br>' +
          'Event ID: ' +
          eventId +
          '<br>' +
          'Event Start Date: ' +
          eventStartDate +
          '<br>' +
          'Event End Date: ' +
          eventEndDate +
          '<br>' +
          'Event Created by: ' +
          given_name +
          ' ' +
          family_name +
          '; ' +
          email +
          '<br>' +
          'Legal Details: ' +
          legalDetails +
          '<br>' +
          'Contract, if provided: ' +
          contract,
        subject_text: 'Review Paused for Event ID: ' + eventId,
        'text-part_text': ''
      };
      let emailTemplate = {
        Source: 'Legal Review <donotreply@t-mobileengagementhub.com>',
        Template: 'no-cta-template',
        ConfigurationSetName: 'ConfigSet',
        Destination: {
          ToAddresses: toAddress?.split(',') ?? [],
        },
        TemplateData: JSON.stringify(templateData, null, 2)
      };
      return emailTemplate;
    },
    userEventPauseEmail(toAddress, eventName) {
      let eventStartDate = `${this.CURRENT_EVENT_OBJECT.startDate} ${this.CURRENT_EVENT_OBJECT.startTime}`;
      let eventEndDate = `${this.CURRENT_EVENT_OBJECT.endDate} ${this.CURRENT_EVENT_OBJECT.endTime}`;
      let given_name = this.CURRENT_EVENT_OBJECT.createdByFirstName;
      let family_name = this.CURRENT_EVENT_OBJECT.createdByLastName;
      let email = this.CURRENT_EVENT_OBJECT.createdByEmail;
      let legalDetails = this.CURRENT_EVENT_OBJECT.legalDetails;
      let contract = this.CURRENT_EVENT_OBJECT.legalContract
        ? this.CURRENT_EVENT_OBJECT.legalContract
        : 'N/A';

      let templateData = {
        preheader_text: '',
        header_text: 'T-Mobile Engagement Hub Pause',
        greeting_text: `Greetings,`,
        'body-1_text': 'Your event submission has been paused.',
        'body-2_text':
          'Event Name: ' +
          eventName +
          '<br>' +
          'Event Start Date: ' +
          eventStartDate +
          '<br>' +
          'Event End Date: ' +
          eventEndDate +
          '<br>' +
          'Event Created by: ' +
          given_name +
          ' ' +
          family_name +
          '; ' +
          email +
          '<br>' +
          'Legal Details: ' +
          legalDetails +
          '<br>' +
          'Contract, if provided: ' +
          contract,
        subject_text: 'Pause Alert for Event ID: ' + this.$route.params.id,
        'text-part_text': ''
      };
      let emailTemplate = {
        Source: 'Pause Alert <donotreply@t-mobileengagementhub.com>',
        Template: 'no-cta-template',
        ConfigurationSetName: 'ConfigSet',
        Destination: {
          ToAddresses: [`${toAddress}`]
        },
        TemplateData: JSON.stringify(templateData, null, 2)
      };
      return emailTemplate;
    },
    pauseTranslationEmail(toAddress, eventName) {
      let eventId = this.$route.params.id;
      let eventStartDate = `${this.CURRENT_EVENT_OBJECT.startDate} ${this.CURRENT_EVENT_OBJECT.startTime}`;
      let eventEndDate = `${this.CURRENT_EVENT_OBJECT.endDate} ${this.CURRENT_EVENT_OBJECT.endTime}`;
      let given_name = this.CURRENT_EVENT_OBJECT.createdByFirstName;
      let family_name = this.CURRENT_EVENT_OBJECT.createdByLastName;
      let email = this.CURRENT_EVENT_OBJECT.createdByEmail;
      let legalDetails = this.CURRENT_EVENT_OBJECT.legalDetails;
      let contract = this.CURRENT_EVENT_OBJECT.legalContract
        ? this.CURRENT_EVENT_OBJECT.legalContract
        : 'N/A';

      let templateData = {
        preheader_text: '',
        header_text: 'Translation Paused',
        greeting_text: `Hi, Translation Team,`,
        'body-1_text':
          'An event that had previously been submitted for translation is currently being edited. You will not be able to complete translations on the event listed below until it is re-submitted for approval.',
        'body-2_text':
          'Event Name: ' +
          eventName +
          '<br>' +
          'Event ID: ' +
          eventId +
          '<br>' +
          'Event Start Date: ' +
          eventStartDate +
          '<br>' +
          'Event End Date: ' +
          eventEndDate +
          '<br>' +
          'Event Created by: ' +
          given_name +
          ' ' +
          family_name +
          '; ' +
          email +
          '<br>' +
          'Legal Details: ' +
          legalDetails +
          '<br>' +
          'Contract, if provided: ' +
          contract,
        subject_text: 'Translation Paused for Event ID: ' + eventId,
        'text-part_text': ''
      };
      let emailTemplate = {
        Source: 'Translation <donotreply@t-mobileengagementhub.com>',
        Template: 'no-cta-template',
        ConfigurationSetName: 'ConfigSet',
        Destination: {
          ToAddresses: toAddress?.split(',') ?? [],
        },
        TemplateData: JSON.stringify(templateData, null, 2)
      };
      return emailTemplate;
    },
    async downloadRulesPDF(lang) {
      if (this.CURRENT_EVENT_OBJECT.legalPdfUrl) {
        try {
          // 1. Fetch the uploaded PDF from S3
          const response = await fetch(this.CURRENT_EVENT_OBJECT.legalPdfUrl);
          const existingPdfBytes = await response.arrayBuffer();

          // 2. Load the PDF document
          const pdfDoc = await PDFDocument.load(existingPdfBytes);
          const pages = pdfDoc.getPages();
          const totalPages = pages.length;

          // 3. Brand Banner Configuration
          const brand = this.CURRENT_EVENT_OBJECT.brand || 'T-Mobile';
          const isMetro = brand.toLowerCase().includes('metro');

          // Parse hex to RGB (0-1 range for pdf-lib)
          const r = isMetro ? 0x46 / 255 : 0xe2 / 255;
          const g = isMetro ? 0x19 / 255 : 0x00 / 255;
          const b = isMetro ? 0x6e / 255 : 0x74 / 255;

          // 4. Draw Header Banner on the first page
          if (pages.length > 0) {
            const firstPage = pages[0];
            const { width, height } = firstPage.getSize();
            const bannerHeight = 100; // ~1.4 inches in points (72 points = 1 inch)

            // Shift existing content on the first page down by bannerHeight points
            // to make room for our banner without covering anything!
            firstPage.translateContent(0, -bannerHeight);
            firstPage.resetPosition();

            // Draw banner background at the top of the first page
            firstPage.drawRectangle({
              x: 0,
              y: height - bannerHeight,
              width: width,
              height: bannerHeight,
              color: rgb(r, g, b),
            });

            // Draw Title Text inside the banner
            const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
            const rulesTitle = this.CURRENT_EVENT_OBJECT.sweepstakesTitle || this.CURRENT_EVENT_OBJECT.name;
            const docTitle = (lang === 'es'
              ? `${rulesTitle} Reglamento Oficial`
              : `${rulesTitle} Official Rules`).toUpperCase();

            // Word-wrap title to fit banner perfectly
            const fontSize = 14;
            const maxTextWidth = width - 100;
            const words = docTitle.split(' ');
            let lines = [];
            let currentLine = '';

            words.forEach(word => {
              const testLine = currentLine ? `${currentLine} ${word}` : word;
              const testWidth = font.widthOfTextAtSize(testLine, fontSize);
              if (testWidth > maxTextWidth) {
                lines.push(currentLine);
                currentLine = word;
              } else {
                currentLine = testLine;
              }
            });
            if (currentLine) {
              lines.push(currentLine);
            }

            const lineHeight = fontSize * 1.25;
            let titleY = height - (bannerHeight - (lines.length * lineHeight)) / 2 - fontSize;

            lines.forEach(line => {
              const textWidth = font.widthOfTextAtSize(line, fontSize);
              firstPage.drawText(line, {
                x: (width - textWidth) / 2,
                y: titleY,
                size: fontSize,
                font: font,
                color: rgb(1, 1, 1),
              });
              titleY -= lineHeight;
            });
          }

          // 5. Draw Footer (Page Numbering) on all pages
          const fontRegular = await pdfDoc.embedFont(StandardFonts.Helvetica);
          const footerFontSize = 9;
          const footerColor = rgb(120 / 255, 120 / 255, 120 / 255);

          pages.forEach((page, idx) => {
            const { width } = page.getSize();
            const pageNum = idx + 1;
            const pageText = lang === 'es'
              ? `Página ${pageNum} de ${totalPages}`
              : `Page ${pageNum} of ${totalPages}`;

            const textWidth = fontRegular.widthOfTextAtSize(pageText, footerFontSize);
            page.drawText(pageText, {
              x: width - textWidth - 54, // 0.75 in margin (54 points)
              y: 30, // ~0.4 in from bottom
              size: footerFontSize,
              font: fontRegular,
              color: footerColor,
            });
          });

          // 6. Serialize and save the PDF document
          const pdfBytesModified = await pdfDoc.save();
          const blob = new Blob([pdfBytesModified], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `${(this.CURRENT_EVENT_OBJECT.sweepstakesTitle || this.CURRENT_EVENT_OBJECT.name).replace(/\s+/g, '_')}_Official_Rules_${lang}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return;
        } catch (err) {
          console.error('Error modifying custom PDF with pdf-lib', err);
        }
      }

      const originalLocale = this.$i18n.locale;
      try {
        this.$i18n.locale = lang;
        if (this.CURRENT_EVENT_OBJECT.eventLanguage === 'bi') {
          await this.fetchTranslations(this.$route.params.id);
        }

        const doc = new jsPDF({
          orientation: 'portrait',
          unit: 'in',
          format: 'letter'
        });

        const pageWidth = 8.5;
        const pageHeight = 11;
        const margin = 0.75;
        const maxLineWidth = pageWidth - (margin * 2);
        let y = margin;

        const stripHtml = (html) => {
          if (!html) return '';
          return html.replace(/<[^>]*>/g, '')
            .replace(/&​amp;/g, '&')
            .replace(/&​lt;/g, '<')
            .replace(/&​gt;/g, '>')
            .replace(/&​quot;/g, '"')
            .replace(/&​#039;/g, "'")
            .trim();
        };

        // Brand Banner Configuration
        const brand = this.CURRENT_EVENT_OBJECT.brand || 'T-Mobile';
        const primaryColor = brand.toLowerCase().includes('metro') ? '#46196e' : '#e20074';
        const bannerHeight = 1.4;

        // Draw First Page Brand Banner
        doc.setFillColor(primaryColor);
        doc.rect(0, 0, pageWidth, bannerHeight, 'F');

        // Center Title vertically & horizontally inside the banner
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor('#ffffff');

        const rulesTitle = this.CURRENT_EVENT_OBJECT.sweepstakesTitle || this.CURRENT_EVENT_OBJECT.name;
        const docTitle = lang === 'es'
          ? `${rulesTitle} Reglamento Oficial`
          : `${rulesTitle} Official Rules`;

        const titleLines = doc.splitTextToSize(docTitle.toUpperCase(), maxLineWidth);
        const titleLineHeight = (14 / 72) * 1.25;
        let titleY = (bannerHeight - (titleLines.length * titleLineHeight)) / 2;
        titleLines.forEach(line => {
          const textWidth = doc.getTextWidth(line);
          const x = margin + (maxLineWidth - textWidth) / 2;
          doc.text(line, x, titleY, { baseline: 'top' });
          titleY += titleLineHeight;
        });

        // Restore content text color to black/grey and start drawing content
        doc.setTextColor(33, 33, 33);
        y = bannerHeight + 0.35; // Content begins nicely below the banner

        // Table Drawer Helper
        const drawPDFTable = (headers, rows) => {
          const colWidth = maxLineWidth / headers.length;
          const rowHeight = 0.25;
          const headerHeight = 0.3;
          const totalTableHeight = headerHeight + (rows.length * rowHeight) + 0.15;

          if (y + totalTableHeight > pageHeight - margin) {
            doc.addPage();
            y = margin;
          } else {
            y += 0.1;
          }

          // Draw Header Shading & Borders
          doc.setFillColor(242, 242, 242);
          doc.rect(margin, y, maxLineWidth, headerHeight, 'F');
          doc.setDrawColor(200, 200, 200);
          doc.setLineWidth(0.01);
          doc.rect(margin, y, maxLineWidth, headerHeight, 'S');

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8);
          doc.setTextColor(60, 60, 60);

          headers.forEach((header, index) => {
            const cellX = margin + (index * colWidth);
            const textWidth = doc.getTextWidth(header);
            const textX = cellX + (colWidth - textWidth) / 2;
            doc.text(header, textX, y + (headerHeight - (8 / 72)) / 2 + 0.01, { baseline: 'top' });
          });

          y += headerHeight;

          // Draw Row Shading & Borders
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(33, 33, 33);
          rows.forEach(row => {
            doc.setFillColor(255, 255, 255);
            doc.rect(margin, y, maxLineWidth, rowHeight, 'F');
            doc.rect(margin, y, maxLineWidth, rowHeight, 'S');

            headers.forEach((cell, colIndex) => {
              const cellX = margin + (colIndex * colWidth);
              const cellValue = String(row[colIndex] || '');
              const textWidth = doc.getTextWidth(cellValue);
              const textX = cellX + (colWidth - textWidth) / 2;
              doc.text(cellValue, textX, y + (rowHeight - (8 / 72)) / 2 + 0.01, { baseline: 'top' });
            });

            y += rowHeight;
          });

          y += 0.15; // padding below table
        };

        const drawListItemTitle = (num, title) => {
          if (!title) return;
          const titleText = `${num}. ${title}:`;
          const lines = doc.splitTextToSize(titleText, maxLineWidth);
          const lineHeight = (10 / 72) * 1.25;
          const height = (lines.length * lineHeight) + 0.15;

          if (y + height > pageHeight - margin) {
            doc.addPage();
            y = margin;
          } else {
            y += 0.15;
          }

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10);
          lines.forEach(line => {
            doc.text(line, margin, y, { baseline: 'top' });
            y += lineHeight;
          });
        };

        const drawParagraph = (text, spacing = 0.05) => {
          if (!text) return;
          const lines = doc.splitTextToSize(text, maxLineWidth);
          const lineHeight = (10 / 72) * 1.25;
          const height = (lines.length * lineHeight) + spacing;

          if (y + height > pageHeight - margin) {
            doc.addPage();
            y = margin;
          } else {
            y += spacing;
          }

          doc.setFont('helvetica', 'normal');
          doc.setFontSize(10);
          lines.forEach(line => {
            doc.text(line, margin, y, { baseline: 'top' });
            y += lineHeight;
          });
        };

        // Render Pre-header sections (bold / centered)
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        const noPurchaseText = stripHtml(this.$t('rules.no_purchase_necessary'));
        const noPurchaseLines = doc.splitTextToSize(noPurchaseText, maxLineWidth);
        const noPurchaseHeight = (noPurchaseLines.length * (10 / 72) * 1.25);
        if (y + noPurchaseHeight > pageHeight - margin) {
          doc.addPage();
          y = margin;
        }
        noPurchaseLines.forEach(line => {
          const textWidth = doc.getTextWidth(line);
          const x = margin + (maxLineWidth - textWidth) / 2;
          doc.text(line, x, y, { baseline: 'top' });
          y += (10 / 72) * 1.25;
        });
        y += 0.15;

        // Render intro section
        drawParagraph(stripHtml(this.$t('rules.by_participating')), 0.05);

        // Precompute Variables
        const formattedEligibleStates = () => {
          const states = this.CURRENT_EVENT_OBJECT.eligibleStates;
          if (!states || states.length === 0 || states.length >= 52) {
            return this.$t('rules.eligibility.all_states');
          }
          if (states.length === 1) {
            return states[0];
          }
          if (states.length === 2) {
            return `${states[0]} and ${states[1]}`;
          }
          return states.slice(0, -1).join(', ') + ' and ' + states[states.length - 1];
        };

        const locationText = this.CURRENT_EVENT_OBJECT.eventLocation;
        let entryContent = { type: '' };
        const host = window.location.origin;
        if (locationText === 'Online/Virtual Event') {
          entryContent = {
            type: 'online',
            url: host + '/#/engagements/register/' + this.CURRENT_EVENT_OBJECT.id
          };
        } else if (locationText === 'Physical/In Person Event') {
          entryContent = {
            type: 'physical',
            address: this.CURRENT_EVENT_OBJECT.physicalEventAddress,
            city: this.CURRENT_EVENT_OBJECT.physicalEventCity,
            state: this.CURRENT_EVENT_OBJECT.state,
            zip: this.CURRENT_EVENT_OBJECT.physicalEventZip
          };
        } else if (locationText === 'Combination Online/In Person') {
          entryContent = {
            type: 'combination',
            url: host + '/#/engagements/register/' + this.CURRENT_EVENT_OBJECT.id,
            address: this.CURRENT_EVENT_OBJECT.physicalEventAddress,
            city: this.CURRENT_EVENT_OBJECT.physicalEventCity,
            state: this.CURRENT_EVENT_OBJECT.state,
            zip: this.CURRENT_EVENT_OBJECT.physicalEventZip
          };
        }

        const getFormattedPrizeDescription = () => {
          if (lang === 'es') {
            if (this.translations.fullPrizeDescription) {
              return this.translations.fullPrizeDescription;
            } else if (this.CURRENT_EVENT_OBJECT.fullPrizeDescription) {
              return this.CURRENT_EVENT_OBJECT.fullPrizeDescription;
            } else {
              return 'No premio';
            }
          } else {
            if (this.CURRENT_EVENT_OBJECT.fullPrizeDescription) {
              return this.CURRENT_EVENT_OBJECT.fullPrizeDescription;
            } else {
              return 'No Prize.';
            }
          }
        };

        // 1. Timing
        const timingDesc = stripHtml(this.$t('rules.timing.description', {
          endDate: this.CURRENT_EVENT_OBJECT.endDate,
          endTime: this.CURRENT_EVENT_OBJECT.endTime,
          startDate: this.CURRENT_EVENT_OBJECT.startDate,
          startTime: this.CURRENT_EVENT_OBJECT.startTime,
          sweepstakesTitle: this.CURRENT_EVENT_OBJECT.sweepstakesTitle || this.CURRENT_EVENT_OBJECT.name,
          timeZone: this.$t('rules.timezone.' + this.CURRENT_EVENT_OBJECT.timezone),
        }));
        drawListItemTitle(1, this.$t('rules.timing.title'));
        drawParagraph(timingDesc);
        if (this.CURRENT_EVENT_OBJECT.intervals && this.CURRENT_EVENT_OBJECT.intervals.length > 1) {
          const timingHeaders = [
            this.$t('rules.start_date'),
            this.$t('rules.start_time'),
            this.$t('rules.end_date'),
            this.$t('rules.end_time')
          ];
          const timingRows = this.CURRENT_EVENT_OBJECT.intervals.map(interval => [
            interval.startDate,
            interval.startTime,
            interval.endDate,
            interval.endTime
          ]);
          drawPDFTable(timingHeaders, timingRows);
        }

        // 2. Eligibility
        const eligibilityDesc = stripHtml(this.$t('rules.eligibility.description', {
          states: formattedEligibleStates(),
        }));
        drawListItemTitle(2, this.$t('rules.eligibility.title'));
        drawParagraph(eligibilityDesc);

        // 3. Entry
        const entryDescBegin = this.$t('rules.entry.begin_description');
        const entryDescType = this.$t('rules.entry.' + entryContent.type, {
          url: entryContent.url,
          address: entryContent.address,
          city: entryContent.city,
          state: entryContent.state,
          zip: entryContent.zip
        });
        const entryDescEnd = this.$t('rules.entry.end_description');
        const entryDesc = stripHtml(`${entryDescBegin} ${entryDescType} ${entryDescEnd}`);
        drawListItemTitle(3, this.$t('rules.entry.title'));
        drawParagraph(entryDesc);

        // 4. Additional Terms
        const additionalTermsDesc = stripHtml(this.$t('rules.additional_terms.description'));
        drawListItemTitle(4, this.$t('rules.additional_terms.title'));
        drawParagraph(additionalTermsDesc);

        // 5. Winner Selection
        const winnerSelectionBegin = this.$t('rules.winner_selection.begin_description', {
          numberOfWinners: this.CURRENT_EVENT_OBJECT.numberOfWinners
        });
        const winnerSelectionEnd = this.$t('rules.winner_selection.end_description');
        const winnerSelectionDesc = stripHtml(winnerSelectionBegin);
        drawListItemTitle(5, this.$t('rules.winner_selection.title'));
        drawParagraph(winnerSelectionDesc);

        if ((this.CURRENT_EVENT_OBJECT.winnerSelectionDate && this.CURRENT_EVENT_OBJECT.winnerSelectionTime) || (this.CURRENT_EVENT_OBJECT.intervals && this.CURRENT_EVENT_OBJECT.intervals.length)) {
          const winnerSelectionHeaders = [
            this.$t('rules.start_date'),
            this.$t('rules.start_time'),
            this.$t('rules.end_date'),
            this.$t('rules.end_time'),
            this.$t('rules.drawing_date'),
            this.$t('rules.drawing_time')
          ];
          const getWinnerSelectionDate = () => {
            if (this.CURRENT_EVENT_OBJECT.winnerSelectionDate) {
              return this.CURRENT_EVENT_OBJECT.winnerSelectionDate;
            }
            if (this.CURRENT_EVENT_OBJECT.intervals && this.CURRENT_EVENT_OBJECT.intervals.length) {
              return this.CURRENT_EVENT_OBJECT.intervals[this.CURRENT_EVENT_OBJECT.intervals.length - 1].winnerSelectionDate;
            }
            return '';
          };
          const getWinnerSelectionTime = () => {
            if (this.CURRENT_EVENT_OBJECT.winnerSelectionTime) {
              return this.CURRENT_EVENT_OBJECT.winnerSelectionTime;
            }
            if (this.CURRENT_EVENT_OBJECT.intervals && this.CURRENT_EVENT_OBJECT.intervals.length) {
              return this.CURRENT_EVENT_OBJECT.intervals[this.CURRENT_EVENT_OBJECT.intervals.length - 1].winnerSelectionTime;
            }
            return '';
          };
          const winnerSelectionRow = [
            this.CURRENT_EVENT_OBJECT.startDate,
            this.CURRENT_EVENT_OBJECT.startTime,
            this.CURRENT_EVENT_OBJECT.endDate,
            this.CURRENT_EVENT_OBJECT.endTime,
            getWinnerSelectionDate(),
            getWinnerSelectionTime()
          ];
          drawPDFTable(winnerSelectionHeaders, [winnerSelectionRow]);
        }
        drawParagraph(stripHtml(winnerSelectionEnd));

        // 6. Prizes
        const prizesBegin = this.$t('rules.prizes.begin_description');
        const prizeDetails = getFormattedPrizeDescription();
        const prizesEnd = this.$t('rules.prizes.end_description', {
          arv: this.CURRENT_EVENT_OBJECT.arv
        });
        const prizesDesc = stripHtml(`${prizesBegin} ${prizeDetails} ${prizesEnd}`);
        drawListItemTitle(6, this.$t('rules.prizes.title'));
        drawParagraph(prizesDesc);

        // 7. Additional Prize Terms
        const additionalPrizeTermsDesc = stripHtml(this.$t('rules.additional_prize_terms.description'));
        drawListItemTitle(7, this.$t('rules.additional_prize_terms.title'));
        drawParagraph(additionalPrizeTermsDesc);

        // 8. Claiming Prize
        const claimingPrizeDesc = stripHtml(this.$t('rules.claiming_prize.description'));
        drawListItemTitle(8, this.$t('rules.claiming_prize.title'));
        drawParagraph(claimingPrizeDesc);

        // 9. Limitations
        const limitationsDesc = stripHtml(this.$t('rules.limitations.description'));
        drawListItemTitle(9, this.$t('rules.limitations.title'));
        drawParagraph(limitationsDesc);

        // 10. Agreement
        const agreementDesc = stripHtml(this.$t('rules.agreement.description'));
        drawListItemTitle(10, this.$t('rules.agreement.title'));
        drawParagraph(agreementDesc);

        // 11. Governing Law
        const governingLawDesc = stripHtml(this.$t('rules.governing_law.description'));
        drawListItemTitle(11, this.$t('rules.governing_law.title'));
        drawParagraph(governingLawDesc);

        // 12. Winners List
        const winnersListDesc = stripHtml(this.$t('rules.winners_list.description'));
        drawListItemTitle(12, this.$t('rules.winners_list.title'));
        drawParagraph(winnersListDesc);

        // 13. Privacy Policy
        const privacyPolicyDesc = stripHtml(this.$t('rules.privacy_policy.description'));
        drawListItemTitle(13, this.$t('rules.privacy_policy.title'));
        drawParagraph(privacyPolicyDesc);

        // 14. Sponsor
        const sponsorDesc = stripHtml(this.$t('rules.sponsor.description'));
        drawListItemTitle(14, this.$t('rules.sponsor.title'));
        drawParagraph(sponsorDesc);

        // 15. Exchange (no title)
        const exchangeDesc = stripHtml(this.$t('rules.exchange.description'));
        drawListItemTitle(15, null);
        drawParagraph(exchangeDesc);

        // Page Numbering Footer Pass
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9);
          doc.setTextColor(120, 120, 120);
          const pageText = lang === 'es' ? `Página ${i} de ${totalPages}` : `Page ${i} of ${totalPages}`;
          doc.text(pageText, pageWidth - margin, pageHeight - 0.4, { align: 'right' });
        }

        doc.save(`${rulesTitle.replace(/\s+/g, '_')}_Official_Rules_${lang}.pdf`);
      } catch (err) {
        console.error('Error generating rules PDF', err);
      } finally {
        this.$i18n.locale = originalLocale;
      }
    }

    //Emails End
  },
  computed: {
    ...mapState('EVENT_MANAGER_STORE', [
      'CURRENT_EVENT_OBJECT',
      'LOADING',
      'BITLY_LINK',
      'API_CALL_IN_PROGRESS'
    ]),
    ...mapGetters({
      IS_ADMIN: `account/IS_ADMIN`,
      IS_DEVELOPER: `account/IS_DEVELOPER`,
      userAttributes: `account/USER_ATTRIBUTES`,
      translations: `translations`
    }),
    ...mapState('PROXY_STORE', ['TABLE_DATA']),
    ...mapState('LEGAL_STORE', ['CURRENT_LEGAL_OBJECT']),
    ...mapState('EVENT_HISTORY_STORE', ['HISTORY_TABLE_DATA']),
    hideAllFormButtons() {
      //
      if (!this.userAttributes['email']) return true;
      if (
        this.CURRENT_EVENT_OBJECT['createdByEmail'] &&
        this.CURRENT_EVENT_OBJECT['createdByEmail'] ===
        this.userAttributes['email']
      )
        return false;
      if (this.IS_ADMIN) {
        return false;
      }

      return !this.TABLE_DATA.filter(
        proxy =>
          proxy.users_email === this.userAttributes['email'].toLowerCase()
      ).length;
    },
    brandWatcher() {
      return this.CURRENT_EVENT_OBJECT && this.CURRENT_EVENT_OBJECT.brand
        ? this.CURRENT_EVENT_OBJECT.brand
        : 'T-Mobile';
    },
    eventName() {
      return this.LOADING
        ? null
        : !this.CURRENT_EVENT_OBJECT.name
          ? null
          : this.CURRENT_EVENT_OBJECT.name;
    },
    eventStatusTitle() {
      return !this.CURRENT_EVENT_OBJECT.status
        ? 'Loading'
        : this.CURRENT_EVENT_OBJECT.archived
          ? 'Archived'
          : this.CURRENT_EVENT_OBJECT.status;
    },
    urlRoot() {
      return window.location.origin;
    },
    event_code() {
      return this.CURRENT_EVENT_OBJECT.event_code || null;
    },
    validateDraftEvtObj() {
      let errorArr = [];
      const errors = validate(this.CURRENT_EVENT_OBJECT, DraftEventSchema);

      if (errors.length > 0) {
        for (const { message } of errors) {
          errorArr.push(message);
        }
      } else {
        errorArr = [];
      }
      return errorArr;
    },
    validateSubmitToLegal() {
      let errorArr = [];
      let enterToWin =
        this.CURRENT_EVENT_OBJECT.contestType === 'Enter for a Chance to Win';
      const errors = validate(
        this.CURRENT_EVENT_OBJECT,
        enterToWin ? EnterToWinEventSchema : SubmitToLegalEventSchema
      );

      if (errors.length > 0) {
        for (const { message } of errors) {
          errorArr.push(message);
        }
      } else {
        errorArr = [];
      }
      return errorArr;
    },
    validateSubmitToTranslations() {
      let errorArr = [];
      let enterToWin =
        this.CURRENT_EVENT_OBJECT.contestType === 'Enter for a Chance to Win';
      const errors = validate(
        this.CURRENT_EVENT_OBJECT,
        enterToWin ? EnterToWinEventSchema : SubmitToTranslationSchema
      );

      if (errors.length > 0) {
        for (const { message } of errors) {
          errorArr.push(message);
        }
      } else {
        errorArr = [];
      }
      return errorArr;
    },
    validateSubmitBatchEvent() {
      let errorArr = [];
      const errors = validate(
        this.CURRENT_EVENT_OBJECT,
        BatchImportEventSchema
      );

      if (errors.length > 0) {
        for (const { message } of errors) {
          errorArr.push(message);
        }
      } else {
        errorArr = [];
      }
      return errorArr;
    },
    isBatchEvent() {
      return this.LOADING
        ? false
        : !this.CURRENT_EVENT_OBJECT.contestType
          ? false
          : this.CURRENT_EVENT_OBJECT.contestType === 'Batch Import Event';
    },
    canDeleteEvent() {
      return this.IS_ADMIN || (
        ['Draft', 'Legal Pending'].includes(this.CURRENT_EVENT_OBJECT.status) &&
        !this.CURRENT_EVENT_OBJECT.archived
      );
    },
    canPauseLegalReview() {
      return this.IS_ADMIN || (
        this.CURRENT_EVENT_OBJECT.status === 'Legal Pending' &&
        this.showUpdateButton &&
        !this.CURRENT_EVENT_OBJECT.archived
      );
    },
    canPauseTranslate() {
      return this.IS_ADMIN || (!this.LOADING &&
        this.CURRENT_EVENT_OBJECT.status === 'Translation Pending' &&
        this.showUpdateButton &&
        !this.CURRENT_EVENT_OBJECT.archived);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.UNTRACKED_CHANGES_TO_EVENT) {
      this.untrackedChangesDialog = true;
      this.targetToRoute = to.fullPath || to.path;
    } else {
      next();
    }
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return;

    window.removeEventListener('resize', this.onResize, { passive: true });
    this.$store.commit('UI_STORE/TOGGLE_EXPANSION_PANEL', 'hide');
  }
};
</script>

<style scoped>
.loading-row {
  padding: 32px;
  text-align: center;
}
</style>
<style lang="scss" scoped>
::v-deep .event-brand .v-input--selection-controls__input {
  display: none;
}

::v-deep .v-input--checkbox {
  margin-top: 0;
}

.date-time-picker-wrap .v-text-field {
  margin-top: 0px;
}

::v-deep .v-input--radio-group {
  margin-top: 0;
  padding-top: 0;
}

.fixed-buttons {
  position: fixed;
  bottom: 0px;
  width: 100%;
  background-color: #9b9b9b;
  padding-top: 15px;
  padding-bottom: 15px;
  z-index: 1;
}

.exit-button {
  background-color: white;
}

.button-text {
  font-weight: bold;
}

::v-deep .v-btn--outlined {
  border-width: 2px !important;
}

.wide-container {
  // max-width: 1442px;
  margin: auto;

  .row {
    @media (min-width: 1400px) {
      max-width: 1706px;
      margin: auto;
    }

    @media (max-width: 767px) {
      max-width: 100vw;
      margin-right: 0;
      margin-left: 0;
    }
  }
}

@media (max-width: 1470px) {
  // .wide-container {
  //   // width: 90%;
  // }
}

.event-link {
  font-weight: bold;
}

.bitly-skeleton {
  display: inline-block;
  width: 100px;
  margin-top: 5px;
}

.form-buttons {
  margin-top: 50px;
  margin-bottom: 80px;
}

@media only screen and (max-width: 767px) {
  .container {
    padding: 0;
  }
}
::v-deep .form-section .gutter-padding {
  @media only screen and (max-width: 767px) {
    padding: 0;
  }
}
</style>
